import React from "react";
import {useQuery} from "../../hooks/use_query";
import {useRequestLogin} from "../../hooks/use_request_login";
import HeadTitle from "../head_title";
import Layout from "../layout/layout";
import styles from '../../styles/external_quotation/request_sign_in.module.scss';

export default function ExternalQuotationsRequestSignIn() {
  const [requestingLink, setRequestingLink] = React.useState<string | undefined>(undefined);

  const requestingLinkRaw = useQuery('requestLink');
  const requestLogin = useRequestLogin();

  React.useEffect(() => {
    if (!requestingLinkRaw) {
      return;
    }

    try {
      new URL(requestingLinkRaw);
    } catch (e) {
      return;
    }

    setRequestingLink(requestingLinkRaw);
  }, [requestingLinkRaw]);

  const isRequestingQuotation = !!requestingLinkRaw;

  return <Layout>
    <HeadTitle title="External Quotations" />

    <div className={styles.container}>
      {isRequestingQuotation ? (<div>
        The website you provided us, has yet integrated into our shopping experience.
        <br/>
        But we'll be happy to quote you accordingly with the link you provided us:
        <br/>
        <code>{requestingLink}</code>
        <br/>
        However, please sign in prior to the quotation request.
      </div>): (
        <div>
          Please login to view your quotations.
        </div>
      )}

      <button className="btn btn-primary mt-2" onClick={requestLogin}>Sign in</button>
    </div>
  </Layout>;
}